import { GROUP_NAME_ICONS } from "./groupIcon/groupNameIcons";

const UNGROUPED_NAME = "Other";

const toKey = (name) =>
  name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-");

export const groupPermissionsByGroupName = (permissions) => {
  const groupsByKey = new Map();

  permissions.forEach((permission) => {
    const groupName = permission.groupName?.trim() || UNGROUPED_NAME;
    const key = toKey(groupName);

    if (!groupsByKey.has(key)) {
      groupsByKey.set(key, {
        key,
        name: groupName,
        icon: GROUP_NAME_ICONS[groupName],
        permissions: [],
      });
    }

    groupsByKey.get(key).permissions.push({
      id: permission.id,
      name: permission.displayName || permission.name,
      desc: permission.description || "",
      requires: permission.dependsOn ? [permission.dependsOn] : [],
    });
  });

  return Array.from(groupsByKey.values()).sort((a, b) =>
    a.name.localeCompare(b.name),
  );
};
